/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-04-28 09:56:24
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-24 11:19:42
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\treatment\api\crossApi.js
 */
// 疗程管理 右侧模块接口
import request from '@/utils/req.js';

//对照录入模块 查看单条对照录入
export function apiGetPatientFiles(params) {
    return request.get("/admin/patient-files/detail",params);
}
//对照录入病程关联列下拉框数据
export function api_archives_options(params) {
    return request.get('/admin/archives-event/options', params)
}
//对照录入医院查询
export function api_hospital(params={}) {
    return request.post('/admin/hospital/list', params)
}
//科室查询
export function api_department(params) {
    return request.post('/admin/open-department/list', params)
}
//查询其他待对照录入文件
export function api_getOtherFiles(params) {
    return request.post('/admin/patient-files/getOtherFiles', params)
}
//对照录入保存
export function api_getPatientFiles(params) {
    return request.post('/admin/patient-files', params)
}
//对照录入  药品查询
export function api_getdrug(params) {
    return request.get("/admin/drug/",params);
}
//获取任务提醒列表  测试
export function apiGetTask(params) {
    return request.post(`/admin/case-mgr-task/getByWholeCourseId?wholeCourseId=${params}`);
}
//任务提醒标记完成  测试
export function apiPutTaskOver(params) {
    return request.put("/admin/case-mgr-task",params);
}
//打卡异常列表获取  测试
export function apiGetPunchList(a,e) {
    return request.post(`/admin/patient-task/getByWholeCourseId?wholeCourseId=${a}&status=${e}`);
}
//推送提醒        测试
export function apiGetPushRedmind(params) {
    return request.get("/admin/patient-task/redmind",params);
}
//提交确认接口  测试
export function apiPostdoctorConfirm(params) {
    return request.post("/admin/patient-doctor-confirm",params);
}
//报告处理展示问卷
export function selectListExam(params) {
    return request.get("/admin/qs-answer-sheet/getAnswerSheetLog", params)
}
//报告处理展示问卷
export function feedbckStatusUpdate(params) {
    return request.put("/admin/feedback/feedbckstatusupdate", params)
}
//根据事件ID 获取对照录入信息
export function apiGetPatientById(params) {
    return request.get("/admin/patient-files/getByRefId", params)
}
//添加不良事件
export function apiAddAdverseEvent(params) {
    return request.post("/admin/adverse-event", params)
}
//获取上报科室接口
export function apiPlatform_department(params) {
    return request.post("/admin/platform-department/list", params)
}
//获取上报科室接口
export function apiAdverseEventList(params) {
    return request.post("/admin/adverse-event/page", params)
}
//事件修改
export function apiuploadEvent(params) {
    return request.put("/admin/adverse-event", params)
}
//事件删除
export function apideleteEvent(params) {
    return request.delete(`/admin/adverse-event/${params}`)
}
//事件删除
export function apiGetPatientPunchList(params) {
    return request.get(`/admin/patient-task/getPatientTaskAbnormal/${params}`)
}
// //打卡异常推送
// export function apiTaskPushMsg(wholeCourseId,params) {
//     return request.get(`/admin/patient-task/pushMsg/${wholeCourseId}/${params}`)
// }

//打卡异常推送
export function apiTaskPushMsg(params) {
  return request.post(`/admin/patient-task/pushMsg`, params,{loading: true})
}

//常用语 拖拽排序接口
export function apiCommonSetSort(params) {
    return request.post("/admin/common-word/setSort", params)
}

//问卷系统- 入按评估类型问卷重复推送
export function pushUnQualifyExamPaper(params) {
  return request.post("/admin/qs-answer-sheet/pushUnQualifyExamPapertoUser", params,{loading: true})
}

//个案通过审核问卷接口
export function passFeedbackSubmitPatient(params) {
  return request.post(`/admin/patient/passFeedbackSubmitPatient`,params)
}

//标记图片到对照录入
export function checkToFiles(params) {
  return request.post("/admin/patient-files/addToFiles", params)
}

//医生拒绝患者后个案再次提交给医生
export function updateConfirm(params) {
  return request.post("/admin/patient-doctor-confirm/updatePatientDoctorConfirm", params)
}

// 打卡历史数据
export function apiGetHistoryRecorddList(params) {
    return request.post(`/admin/patient-task/getPatientTaskMonthByWholeCourseIdAndMonth`, params);
}

//患者全病程处理接口
export function apiWholeCourseHandler(params) {
  return request.get(`/admin/whole-course/handler/${params}`);
}

// 逻辑生效列表
export function decisionExecutedRecordList(params) {
    return request.post(`/admin/decision-executed-record/listGroupByMonth`, params);
}

// 逻辑执行记录详情
export function getDecisionExecutedRecordDetail(id) {
    return request.get(`/admin/decision-executed-record/${id}`);
}

export function caseSubmitPatient(params) {
    return request.post("/admin/patient/caseSubmitPatient",params)
}
export function wholeCourseRefund(id) {
    return request.get(`/admin/whole-course/wholeCourseRefund?wholeCourseId=${id}`);
}

// 常见问题接口查询
export function getIMCommonQuestions(params) {
    return request.post("/admin/patient-common-question/getIMPatientFaqWithFuzzySearch", params)
}

// 模糊搜索查询所有icd-10病种
export function findIcdDiseaseByCondition(param) {
    return request.get(`/admin/disease-type/findDiseaseTypeByCondition`, param);
}

// 异常指标推送-详情 
export function ocrAnomalyIndexDetail(param) {
    return request.get(`/biz/admin/ocr-anomaly-index/detail`, param);
}

// 协同会诊信息-小结详情
export function getSynergyConclusionDetail(param) {
    return request.get(`/patient/inquiry-info/synergyConclusionDetail`, param);
}

// 协同会诊信息-患者详情
export function getSynergyPatientDetail(param) {
    return request.get(`/patient/inquiry-info/synergyPatientDetail`, param);
}

